import { defineMessages } from "react-intl";

import { BasicModal } from "@/ui-components/commonComponents/Modal/BasicModal";
import { Button } from "@/ui-components/commonComponents/Button/Button";
import {
  AssessmentLogEventsEnum,
  AssessmentLogsHttpService,
} from "@/shared/services/assessments/assessment-logs-http.service";
import { AssessmentCopy, type AssessmentCopyVariants } from "@/modules/candidate/assessmentCopy";

const messages = defineMessages({
  continueAssessment: {
    id: "candidate.taking.assessment.continue",
    defaultMessage: "Continue Assessment",
  },
  continueSurvey: {
    id: "candidate.taking.survey.continue",
    defaultMessage: "Continue Survey",
  },
  assessmentTitle: {
    id: "candidate.taking.assessment.focusLost.title",
    defaultMessage: "Please complete this assessment honestly and on your own.",
  },
  surveyTitle: {
    id: "candidate.taking.survey.focusLost.title",
    defaultMessage: "Please complete this survey honestly and on your own.",
  },
  assessmentBody: {
    id: "candidate.taking.assessment.focusLost.body",
    defaultMessage:
      "We monitor activity during the assessment to ensure fairness and detect potential misuse. We value integrity and want to see your true abilities.",
  },
  surveyBody: {
    id: "candidate.taking.survey.focusLost.body",
    defaultMessage:
      "We monitor activity during the survey to ensure fairness and detect potential misuse. We value integrity and want to see your true abilities.",
  },
});

const continueMessages: AssessmentCopyVariants = {
  assessment: messages.continueAssessment,
  survey: messages.continueSurvey,
};

const titleMessages: AssessmentCopyVariants = {
  assessment: messages.assessmentTitle,
  survey: messages.surveyTitle,
};

const bodyMessages: AssessmentCopyVariants = {
  assessment: messages.assessmentBody,
  survey: messages.surveyBody,
};

export function FocusLostModal({
  isOpen,
  handleClose,
  inviteId,
  testId,
}: {
  isOpen: boolean;
  handleClose: () => void;
  inviteId?: number;
  testId?: number;
}) {
  const handleContinueClick = async () => {
    if (inviteId && testId) {
      await AssessmentLogsHttpService.saveInviteLogs(inviteId, testId, AssessmentLogEventsEnum.ASSESSMENT_FOCUS);
    }
    handleClose();
  };

  return (
    <BasicModal
      autoHeight={true}
      isClosable={false}
      isModalOpen={isOpen}
      maskStyle={{
        backdropFilter: "blur(5px)",
        backgroundColor: "rgba(0, 0, 0, 0.3)",
      }}
      footer={
        <Button onClick={handleContinueClick}>
          <AssessmentCopy variants={continueMessages} />
        </Button>
      }
    >
      <>
        <h1>
          <AssessmentCopy variants={titleMessages} />
        </h1>
        <p>
          <AssessmentCopy variants={bodyMessages} />
        </p>
      </>
    </BasicModal>
  );
}
